var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    transform: "rotate(90 18 18)",
    fill: "#C3966E",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4697 11.8329C17.7626 11.54 18.2374 11.54 18.5303 11.8329L23.3033 16.6058C23.5962 16.8987 23.5962 17.3736 23.3033 17.6665C23.0104 17.9594 22.5355 17.9594 22.2426 17.6665L18 13.4239L13.7574 17.6665C13.4645 17.9594 12.9896 17.9594 12.6967 17.6665C12.4038 17.3736 12.4038 16.8987 12.6967 16.6058L17.4697 11.8329ZM17.25 46L17.25 12.3632H18.75L18.75 46H17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrowTop);
export default __webpack_public_path__ + "static/media/scroll_arrow_top.c095adc6e04dcba3b36bf2b437b75a84.svg";
export { ForwardRef as ReactComponent };